// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get, head, toLower } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import {
    describeNotificationChanges,
    getNotificationElementChangeElementTypes,
} from './utils/notificationEntryElementChangeUtils';
import { isBoard } from '../../../../../../../common/elements/utils/elementTypeUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import NotificationElementChangeSummary from './NotificationElementChangeSummary';
import NewBoardTitleSummary from './NewBoardTitleSummary';
import Icon from '../../../../../../components/icons/Icon';

const Statement = (props) => {
    const { group, element, notification, hasSingleType, elementType } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (!hasSingleType && groupId === boardId) return <span> made these changes:</span>;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    const changeDescription = hasSingleType ? describeNotificationChanges({ notification }) : null;
    const sentence = (hasSingleType && changeDescription.sentence) || ' edited ';

    let boardTitleComponent = null;
    let conjunction = '';

    if (groupId !== boardId) {
        boardTitleComponent = boardTitle ? <span className="board-title">{boardTitle}</span> : <span>a board</span>;

        if (hasSingleType && changeDescription.conjunction) {
            conjunction = ` ${changeDescription.conjunction} `;
        }
    }

    const separator = hasSingleType && isBoard(elementType) ? ':' : '';

    return (
        <span>
            {sentence}
            {conjunction}
            {boardTitleComponent}
            {separator}
        </span>
    );
};

const NotificationEntryBoardUpdate = (props) => {
    const { actors } = props;

    const types = getNotificationElementChangeElementTypes(props);

    const hasSingleType = types.length === 1;
    const elementType = head(types);

    const icon = hasSingleType ? <Icon name={`notification-${toLower(elementType)}`} /> : null;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryBoardUpdate"
            figure={<NotificationUserFigure {...props} icon={icon} />}
        >
            <div className="description">
                <UserNames users={actors} />{' '}
                <Statement {...props} elementType={elementType} hasSingleType={hasSingleType} />
            </div>
            {!hasSingleType && <NotificationElementChangeSummary {...props} />}
            {hasSingleType && isBoard(elementType) && <NewBoardTitleSummary {...props} />}
        </BaseNotificationEntry>
    );
};

Statement.propTypes = NotificationEntryBoardUpdate.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryBoardUpdate;
